import { FormControl, Select as MuiSelect, MenuItem, InputLabel, FormHelperText, SxProps } from '@mui/material';

import { useForm, FormData } from '@carcareers/contexts';

export interface SelectOptions {
  label: string;
  value: string;
}

interface SelectProps {
  name: string;
  options: SelectOptions[];
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: SxProps;
}

export const Select = <T extends FormData>({ name, options, label, fullWidth, disabled, sx }: SelectProps) => {
  const { getData, setData, getErrors } = useForm<T>();

  const errors = getErrors(name);

  return (
    <FormControl error={!!errors} fullWidth={fullWidth}>
      {label && <InputLabel sx={{ backgroundColor: 'background.default', px: 0.5 }} error={!!errors}>{label}</InputLabel>}
      <MuiSelect
        value={getData(name) ?? ''}
        onChange={(e) => setData(name, e.target.value)}
        error={!!errors}
        disabled={disabled}
        sx={sx}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {errors && <FormHelperText error>{errors}</FormHelperText>}
    </FormControl>
  );
};
